import { GridColDef } from "@mui/x-data-grid";
import { TbMapPin } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { WeTrackVehicleData } from "@/types/wetrack.types";

export const AddressColumn = (): GridColDef<WeTrackVehicleData["properties"]> => {
    return {
        field: "address",
        headerName: "currentAddress",
        minWidth: 330,
        flex: 1,
        resizable: true,
        renderHeader: (params) => <TableHeader Component={TbMapPin} title={params.colDef.headerName!} />,
        renderCell: (params) => (
            <div className="flex p-1 items-center font-medium h-full gap-1  text-xs">{params.row.address}</div>
        ),
    };
};
